module.exports = __webpack_public_path__ + "img/5.bf023401.jpg";